<template>
  <div>
    <div class="row">
      <div class="col">
        <label for="username" class="control-label">{{ $t('username') }}</label>
        <fg-input
          type="text"
          id="username"
          :placeholder="$t('username') + '/' + $t('email')"
          v-model="username"
          addon-left-icon="ti ti-user"
          @input="$emit('update:username', username)"
        >
        </fg-input>
      </div>
    </div>
    <VuePassword
      @update:field="$emit('update:password', $event)"
      class="pt-3"
      size="11"
      auto="true"
      characters="a-z,A-Z,0-9"
    >
    </VuePassword>
  </div>
</template>

<script>
import SvgUser from '../svg/SvgUser';
import VuePassword from '../VuePassword';
export default {
  name: 'CreateCredentialContent',
  components: { VuePassword, SvgUser },
  data: function () {
    return {
      username: null,
    };
  },
};
</script>

<style scoped></style>
